/*
 * Journey tracking (docs/spec-analytics.md). bbTrack(name, data) publishes a Shopify custom event; a Custom
 * Pixel (Settings > Customer events) forwards them to Google Analytics once it exists, after the visitor
 * accepts analytics cookies. Until then this does nothing. Never pass personal data (no emails, names).
 * Also records clicks on any link into the box builder or the gift page (bb_cta_click), so we can see which
 * button, on which section of which page, starts most boxes.
 *
 * Campaign tags (UTMs): when a visit lands with utm_* (or src=) in the address, e.g. from the box QR code
 * (go.butcherben.co.uk/box), the first set seen this visit is kept and written onto the basket as hidden
 * attributes (_bb_utm_source, _bb_utm_medium, _bb_utm_campaign, _bb_utm_content, _bb_landing, _bb_src), so
 * every order records where the visit came from. This works without analytics consent (it's the order's own
 * data). The QR doorway also leaves the tags in a bb_qr cookie for a week, read once here, so they survive
 * the store password page or a new tab. Shopify's own reports also read the UTMs.
 */
(function () {
  'use strict';
  function track(name, data) {
    try { var a = window.Shopify && window.Shopify.analytics; if (a && a.publish) a.publish(name, data || {}); } catch (e) { /* never break the page */ }
  }
  window.bbTrack = track;

  var UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  function readUtm() { try { return JSON.parse(sessionStorage.getItem('bb_utm') || 'null'); } catch (e) { return null; } }
  function cartAttrs() {
    var u = readUtm(), a = {};
    if (!u) return a;
    [['utm_source', '_bb_utm_source'], ['utm_medium', '_bb_utm_medium'], ['utm_campaign', '_bb_utm_campaign'], ['utm_content', '_bb_utm_content'],
      ['landing', '_bb_landing'], ['src', '_bb_src']].forEach(function (p) { if (u[p[0]]) a[p[1]] = u[p[0]]; });
    return a;
  }
  // The checkouts (builder, gift) call this too, because emptying the basket can drop attributes.
  track.cartAttrs = cartAttrs;
  // Where this visit came from, for the email capture forms (builder, scratch card): saved on the Klaviyo
  // profile so a sale on another device can still be matched to the QR code or leaflet by email.
  track.leadProps = function () {
    var u = readUtm() || {}, p = {};
    if (u.utm_source) p.bb_first_utm_source = u.utm_source;
    if (u.utm_medium) p.bb_first_utm_medium = u.utm_medium;
    if (u.utm_campaign) p.bb_first_utm_campaign = u.utm_campaign;
    if (u.utm_source === 'qr' && u.utm_campaign) p.bb_qr = 'qr-' + u.utm_campaign;
    return p;
  };
  // Tags left by the QR doorway (go.butcherben.co.uk) in the bb_qr cookie, for when the address lost them
  // (the store password page, a new tab). Read once, then deleted.
  function qrCookie() {
    var m = document.cookie.match(/(?:^|;\s*)bb_qr=([^;]*)/);
    if (!m) return null;
    document.cookie = 'bb_qr=; Domain=butcherben.co.uk; Path=/; Max-Age=0; SameSite=Lax; Secure';
    try { return JSON.parse(decodeURIComponent(m[1])); } catch (e) { return null; }
  }
  (function captureUtm() {
    var q = new URLSearchParams(location.search), u = {};
    UTM.forEach(function (k) { var v = q.get(k); if (v) u[k] = v.slice(0, 100); });
    if (q.get('src')) u.src = q.get('src').slice(0, 40);
    var c = qrCookie();
    if (!Object.keys(u).length && c) {
      UTM.concat(['src']).forEach(function (k) { if (c[k]) u[k] = String(c[k]).slice(0, k === 'src' ? 40 : 100); });
    }
    if (!Object.keys(u).length) return;
    u.landing = location.pathname;
    try {
      if (sessionStorage.getItem('bb_utm')) return; // first campaign of the visit wins
      sessionStorage.setItem('bb_utm', JSON.stringify(u));
      if (!sessionStorage.getItem('bb_source') && u.utm_source) sessionStorage.setItem('bb_source', u.utm_source + (u.utm_medium ? ' / ' + u.utm_medium : ''));
    } catch (e) { /* storage blocked: Shopify's own UTM capture still applies */ }
    fetch('/cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, credentials: 'same-origin', body: JSON.stringify({attributes: cartAttrs()})}).catch(function () {});
    track('bb_campaign_landing', {utm_source: u.utm_source || '', utm_medium: u.utm_medium || '', utm_campaign: u.utm_campaign || '', src: u.src || '', landing: u.landing});
  })();
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var h = a.getAttribute('href') || '';
    var dest = /build-your-box/.test(h) ? 'builder' : /gift-a-box/.test(h) ? 'gift' : '';
    if (!dest) return;
    var sec = a.closest('.shopify-section');
    track('bb_cta_click', {destination: dest, label: (a.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60),
      section: sec ? sec.id.replace(/^shopify-section-((template|sections)--\d+__)?/, '') : '', page: location.pathname});
  }, true);
})();
